var _path, _path2, _path3, _path4, _path5;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDiscord(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 86,
    height: 82,
    viewBox: "0 0 86 82",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M65.5688 26.779C61.4404 23.6783 56.4863 22.128 51.2569 21.8696L50.4312 22.6448C55.1101 23.6783 59.2386 25.7453 63.0917 28.5876C58.4129 26.2621 53.1835 24.7119 47.6789 24.1951C46.0276 23.9367 44.6513 23.9367 43 23.9367C41.3487 23.9367 39.9724 23.9367 38.3211 24.1951C32.8165 24.7119 27.5871 26.2621 22.9082 28.5876C26.7614 25.7453 30.8899 23.6783 35.5688 22.6448L34.7431 21.8696C29.5137 22.128 24.5596 23.6783 20.4312 26.779C15.7523 35.0473 13.2752 44.3492 13 53.9092C17.1284 58.0435 22.9082 60.6274 28.9634 60.6274C28.9634 60.6274 30.8899 58.5603 32.266 56.7515C28.6881 55.9765 25.3853 54.1676 23.1835 51.3256C25.1101 52.359 27.0366 53.3926 28.9634 54.1676C31.4404 55.2013 33.9175 55.7181 36.3946 56.2349C38.5964 56.4931 40.7982 56.7515 43 56.7515C45.2018 56.7515 47.4036 56.4931 49.6054 56.2349C52.0825 55.7181 54.5596 55.2013 57.0366 54.1676C58.9634 53.3926 60.8899 52.359 62.8165 51.3256C60.6147 54.1676 57.3119 55.9765 53.734 56.7515C55.1101 58.5603 57.0366 60.6274 57.0366 60.6274C63.0918 60.6274 68.8716 58.0435 73 53.9092C72.7248 44.3492 70.2477 35.0473 65.5688 26.779ZM33.9175 49.2583C31.1652 49.2583 28.6881 46.9329 28.6881 44.0908C28.6881 41.2485 31.1652 38.923 33.9175 38.923C36.6698 38.923 39.1469 41.2485 39.1469 44.0908C39.1469 46.9329 36.6698 49.2583 33.9175 49.2583ZM52.0825 49.2583C49.3302 49.2583 46.8531 46.9329 46.8531 44.0908C46.8531 41.2485 49.3302 38.923 52.0825 38.923C54.8348 38.923 57.3119 41.2485 57.3119 44.0908C57.3119 46.9329 54.8348 49.2583 52.0825 49.2583Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 80.9999V1.49683H4V11.4348L1 15.4099V68.0807L4 71.0621V80.9999H0Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M86 80.9999V1.49683H82V11.4348L85 15.4099V68.0807L82 71.0621V80.9999H86Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.25,
    d: "M0 1H86",
    stroke: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.25,
    d: "M0 81H86",
    stroke: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDiscord);
export default __webpack_public_path__ + "static/media/discord.4410eae84165f51d523e67e2677694d7.svg";
export { ForwardRef as ReactComponent };